export default "__VITE_ASSET__AGllj$6w__"